import GoogleChatPanel from '../components/chat/GoogleChatPanel';

export default function GoogleChatPage() {
  return <GoogleChatPanel />;
}
